import { ReferentialKey } from 'api/referential';
import { ComponentKey } from 'enums/componentKey';
import { InputsConfig } from 'types/form/inputsConfig';
import { SearchFilterEnum } from 'api/actor';
import { BrokerFormFieldNames } from './BrokerFormFieldNames';
import { BrokerFormValues } from './BrokerFormValues';
import { addressInputsConfig } from 'features/new-actor/form/inputs-config/addressInputsConfig';

import { gerantInputsConfig } from 'back-office/shared/components/gerant/gerantFields';
export const brokerInputsConfig: InputsConfig<keyof BrokerFormValues> = {
  ...gerantInputsConfig,
  ...addressInputsConfig,
  [BrokerFormFieldNames.CompanyName]: {
    componentKey: ComponentKey.InputText,
    name: BrokerFormFieldNames.CompanyName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.COMPANY_NAME',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.COMPANY_NAME',
  },
  [BrokerFormFieldNames.Phone]: {
    componentKey: ComponentKey.InputText,
    name: BrokerFormFieldNames.Phone,
    type: 'tel',
    required: false,
    label: 'ACTOR_FORM.BROKER.LABELS.PHONE',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.PHONE',
    existenceCheck: {
      enabled: true,
      type: 'phone',
      searchFilter: SearchFilterEnum.Phone,
      debounceMs: 500,
      errorMessage: 'Ce numéro de téléphone existe déjà',
    },
  },
  [BrokerFormFieldNames.ComplaintEmail]: {
    componentKey: ComponentKey.InputText,
    name: BrokerFormFieldNames.ComplaintEmail,
    type: 'email',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.COMPLAINT_EMAIL',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.COMPLAINT_EMAIL',
  },
  [BrokerFormFieldNames.RegistrationNumber]: {
    componentKey: ComponentKey.InputText,
    name: BrokerFormFieldNames.RegistrationNumber,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.REGISTRATION_NUMBER',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.REGISTRATION_NUMBER',
    // existenceCheck: {
    //   enabled: true,
    //   type: 'siret',
    //   searchFilter: SearchFilterEnum.Siret,
    //   debounceMs: 500,
    //   errorMessage: 'Ce numéro SIRET existe déjà',
    // },
  },
  [BrokerFormFieldNames.Capital]: {
    componentKey: ComponentKey.InputText,
    name: BrokerFormFieldNames.Capital,
    type: 'number',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.CAPITAL',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.CAPITAL',
    min: 0,
  },
  [BrokerFormFieldNames.RcsCity]: {
    componentKey: ComponentKey.InputText,
    name: BrokerFormFieldNames.RcsCity,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.RCS_CITY',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.RCS_CITY',
  },
  [BrokerFormFieldNames.RcsNumber]: {
    componentKey: ComponentKey.InputText,
    name: BrokerFormFieldNames.RcsNumber,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.RCS_NUMBER',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.RCS_NUMBER',
  },
  [BrokerFormFieldNames.OriasNumber]: {
    componentKey: ComponentKey.InputText,
    name: BrokerFormFieldNames.OriasNumber,
    type: 'text',
    required: true, // ORIAS obligatoire pour la nature Courtier (règle back OriasRequis)
    label: 'ACTOR_FORM.BROKER.LABELS.ORIAS_NUMBER',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.ORIAS_NUMBER_REQUIRED',
  },
  [BrokerFormFieldNames.Rcp]: {
    componentKey: ComponentKey.InputText,
    name: BrokerFormFieldNames.Rcp,
    type: 'text',
    required: false,
    label: 'ACTOR_FORM.BROKER.LABELS.RCP',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.RCP',
  },
  [BrokerFormFieldNames.FirstName]: {
    componentKey: ComponentKey.InputText,
    name: BrokerFormFieldNames.FirstName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.FIRST_NAME',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.FIRST_NAME',
  },
  [BrokerFormFieldNames.LastName]: {
    componentKey: ComponentKey.InputText,
    name: BrokerFormFieldNames.LastName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.LAST_NAME',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.LAST_NAME',
  },
  [BrokerFormFieldNames.Email]: {
    componentKey: ComponentKey.InputText,
    name: BrokerFormFieldNames.Email,
    type: 'email',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.EMAIL',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.EMAIL',
    existenceCheck: {
      enabled: true,
      type: 'email',
      searchFilter: SearchFilterEnum.Email,
      debounceMs: 500,
      errorMessage: 'Cette adresse email existe déjà',
    },
  },
  [BrokerFormFieldNames.PlateformeIds]: {
    componentKey: ComponentKey.ReferentialTagInput,
    name: BrokerFormFieldNames.PlateformeIds,
    referentialKey: ReferentialKey.Plateforme,
    label: 'COMMON.LABELS.ORGANIZATIONS',
    placeholder: 'COMMON.PLACEHOLDERS.ORGANIZATIONS',
    required: false,
  },
  [BrokerFormFieldNames.SousNature]: {
    componentKey: ComponentKey.Dropdown,
    name: BrokerFormFieldNames.SousNature,
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.TYPE_CABINET',
    items: [
      { key: 'CLASSIQUE', label: 'ACTOR_FORM.BROKER.TYPES_CABINET.CLASSIQUE' },
      { key: 'GRO', label: 'ACTOR_FORM.BROKER.TYPES_CABINET.GROSSISTE' },
    ],
  },
  [BrokerFormFieldNames.RoleIds]: {
    componentKey: ComponentKey.Custom,
    name: BrokerFormFieldNames.RoleIds,
  },
  [BrokerFormFieldNames.Collaborators]: {
    componentKey: ComponentKey.Custom,
    name: BrokerFormFieldNames.Collaborators,
  },
  [BrokerFormFieldNames.IsActive]: {
    componentKey: ComponentKey.Switch,
    name: BrokerFormFieldNames.IsActive,
    label: 'ACTOR_FORM.BROKER.LABELS.IS_ACTIVE',
    falseLabel: 'ACTOR_FORM.BROKER.LABELS.IS_INACTIVE',
  },

  [BrokerFormFieldNames.Username]: {
    componentKey: ComponentKey.InputText,
    name: BrokerFormFieldNames.Username,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.USERNAME',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.USERNAME',
  },
  [BrokerFormFieldNames.Password]: {
    componentKey: ComponentKey.InputText,
    name: BrokerFormFieldNames.Password,
    type: 'password',
    required: true,
    label: 'ACTOR_FORM.BROKER.LABELS.PASSWORD',
    placeholder: 'ACTOR_FORM.BROKER.PLACEHOLDERS.PASSWORD',
  },
};
